"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseUrl = exports.parseShUrlProperties = exports.isScriptUrl = exports.isFullUrl = exports.getDomainName = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _supportedLocales = require("@stubhub/supported-locales");
var _PAGE_ID_REGEX_MAP;
/* eslint-disable prefer-destructuring */
/* eslint-disable no-multi-assign */
// Only entities in this list support URL's with seo.
var ENTITY_TYPES = ['event', 'performer', 'venue', 'grouping', 'category', 'geography'];
var HOME_PAGE_ID = 'home';
var PAGE_ID_REGEX_MAP = (_PAGE_ID_REGEX_MAP = {}, (0, _defineProperty2["default"])(_PAGE_ID_REGEX_MAP, HOME_PAGE_ID, /^\/$/), (0, _defineProperty2["default"])(_PAGE_ID_REGEX_MAP, "browse", /\/(performer|venue|grouping|category|geography)\/\d+\/?$/), (0, _defineProperty2["default"])(_PAGE_ID_REGEX_MAP, "search", /\/find\/s\/?$/), (0, _defineProperty2["default"])(_PAGE_ID_REGEX_MAP, "event", /\/event\/\d+\/?$/), _PAGE_ID_REGEX_MAP);
var PAGE_KEYS = Object.keys(PAGE_ID_REGEX_MAP);

// Build a map to support efficient lookup.
var supportedEntities = ENTITY_TYPES.reduce(function (result, entityType) {
  result[entityType] = true;
  return result;
}, {});

/**
 * @param {String} s
 *    Might or might not be an entity type
 * @returns {Boolean}
 */
function isSupportedEntity(s) {
  return supportedEntities[s] === true;
}

// Use of a constant here can apparently help minimize garbage collection?
var NS = '';
var reg_https = /^https/;
var reg_http = /^http/;
var reg_js = /^javascript/i;

// Build a map to support efficient lookup.
var supportedLangs = _supportedLocales.supportedLocales.reduce(function (result, locale) {
  // First two letters of our locale codes are always the language code in lowercase.
  var langLower = locale.substr(0, 2);
  result[langLower] = true;
  return result;
}, {});

/**
 * @param {String} s
 *    Might or might not be a language code
 * @returns {Boolean}
 */
function isSupportedLang(s) {
  return typeof s === 'string' && supportedLangs[s.toLowerCase()] === true;
}

/**
 * Note: We evaluated url-parse library from https://www.npmjs.com/package/url-parse as it can be
 * used to parse out standard parts of a URL. However, it applies different rules for populating the
 * protocol and host when it receives a URL that is not a full absolute URL. For example, for the
 * URL "//www.stubhub.com" the url-parse library sets protocol = "http" whereas our logic that
 * consumes the parsed URL object needs the protocol to be empty in this case. Another example, for
 * "/mya/listings" the url-parse library sets host = "localhost" and our consumers need it to be
 * empty in this case. We had a choice of either adjusting our logic that consumes the URL object,
 * or using our own parsing. We chose to use our own parsing here, which has the extra benefit of
 * saving the file size of another library.
 */

/**
 * Parse a StubHub URL into its components, represented in an object.
 *
 * @param {String} url
 * @returns {Object}
 *     Object with string-valued properties:
 *     protocol: "https:", "http:", "" (empty) or null
 *     host
 *     hostname
 *     port
 *     pathname
 *     sh_seo
 *     sh_lang
 *     sh_pathname
 *     sh_entity
 *     sh_entity_id
 *     search
 *     hash
 *     __raw__
 */

var parseUrl = function parseUrl(url) {
  // We'll return the following object at the end, after populating the relevant properties.
  var urlObject = {
    protocol: NS,
    host: NS,
    hostname: NS,
    port: NS,
    pathname: NS,
    sh_seo: NS,
    sh_lang: NS,
    sh_pathname: NS,
    sh_entity: NS,
    sh_entity_id: NS,
    search: NS,
    hash: NS,
    __raw__: url
  };
  if (reg_https.test(url)) {
    urlObject.protocol = 'https:';
  } else if (reg_http.test(url)) {
    urlObject.protocol = 'http:';
  } else if (url.length >= 2 && url.charAt(0) === '/' && url.charAt(1) === '/') {
    urlObject.protocol = NS;
  } else {
    urlObject.protocol = null;
  }
  if (urlObject.protocol !== null) {
    url = url.replace("".concat(urlObject.protocol, "//"), NS);
    var host = url.split('/')[0];
    urlObject.host = host;
    var _ref = (0, _toConsumableArray2["default"])(host.split(':')),
      hostname = _ref[0],
      _ref$ = _ref[1],
      port = _ref$ === void 0 ? NS : _ref$; // Copies the array
    urlObject.hostname = hostname;
    urlObject.port = port;
    url = url.replace(urlObject.host, NS);
  } else {
    urlObject.protocol = NS; // Set it to empty string
  }

  var hash = url.split('#')[1];
  url = url.replace("#".concat(hash), NS);
  urlObject.hash = hash ? "#".concat(hash) : NS;
  var _ref2 = (0, _toConsumableArray2["default"])(url.split('?')),
    pathname = _ref2[0],
    _ref2$ = _ref2[1],
    search = _ref2$ === void 0 ? NS : _ref2$;

  // Ensure pathname starts with a '/'.
  if (pathname.charAt(0) === '/') {
    urlObject.pathname = pathname;
  } else {
    urlObject.pathname = "/".concat(pathname);
  }
  if (search) {
    urlObject.search = "?".concat(search);
  }

  // Populate sh_* properties.
  parseShUrlProperties(urlObject);
  return urlObject;
}; // ParseUrl

/**
 * Parse the pathname, and populate these StubHub-specific properties in URL object:
 *
 * sh_seo
 * sh_lang
 * sh_pathname
 * sh_entity
 * sh_entity_id
 *
 * Note: The pathname property is already set but might NOT begin with a '/' in some cases, e.g. if
 * the original input URL did not begin with a protocol, host, or '/'.
 *
 * @param {Object} urlObject
 */
exports.parseUrl = parseUrl;
var parseShUrlProperties = function parseShUrlProperties(urlObject) {
  /*
   * Populate StubHub-specific properties. This is tricky stuff. We allow many different URL
   * patterns. The pathname property begins with a leading '/' and can be any of the following:
   *
   * /
   * /lang
   * /appOrStaticPage
   * /lang/appOrStaticPage
   * /entity/id
   * /lang/entity/id
   * /seo/entity/id
   * /lang/seo/entity/id - we tolerate this, but really the lang should come after the seo
   * /seo/lang/entity/id
   */

  // These may be overridden below.
  urlObject.sh_seo = NS;
  urlObject.sh_lang = NS;
  urlObject.sh_pathname = urlObject.pathname;
  urlObject.sh_entity = NS;
  urlObject.sh_entity_id = NS;

  // Tokenize the pathname.
  var pathname = urlObject.pathname; // Always begins with '/'
  var splits = pathname.substr(1).split('/'); // Prevent '' at beginning of array

  /*
   * If there are no tokens, stop now. It means the pathname is '/' and no further assignments are
   * needed. This is just a small optimization.
   */
  var numTokens = splits.length;
  if (numTokens === 1 && splits[0] === NS) {
    // Simply add 'home' page_id to avoid doing regex checks on path for page_id (see below).
    urlObject.sh_page_id = HOME_PAGE_ID;
    return urlObject;
  }

  // Try to detect if its' entity page FIRST
  var entityIndex = -1;
  for (var tokenIndex = 0; tokenIndex < numTokens; tokenIndex++) {
    var token = splits[tokenIndex];
    if (isSupportedEntity(token)) {
      entityIndex = tokenIndex;
      urlObject.sh_entity = token;
      // Next token should be an entity id.
      urlObject.sh_entity_id = splits[tokenIndex + 1];
      // (We don't try to validate the entity id.)
      break;
    }
  }
  var token0 = entityIndex !== 0 ? splits[0] : NS;
  var token1 = token0 && numTokens >= 1 && entityIndex !== 1 ? splits[1] : NS;

  /*
   * Need to capture lang updated pathname, defaults to already set pathname.
   * This is for sh_page_id to get proper path for regex check below.
   */
  var shPathname = pathname;
  if (entityIndex > -1) {
    if (token0 && isSupportedLang(token0)) {
      // Entity page
      // Pattern: /lang/seo?/.*/entity/entityId
      urlObject.sh_lang = token0;
      urlObject.sh_seo = token1;
    } else if (token1 && isSupportedLang(token1)) {
      // Entity page
      // Pattern: /seo?/lang/.*/entity/entityId
      urlObject.sh_lang = token1;
      urlObject.sh_seo = token0;
    } else {
      // Entity page
      // Pattern: /seo?/.*/entity/entityId
      urlObject.sh_seo = token0;
    }
    shPathname = urlObject.sh_pathname = "/".concat(splits.slice(entityIndex).join('/'));

    /*
     * Always end with '/' for entity url for SEO purpose
     * https://webmasters.googleblog.com/2010/04/to-slash-or-not-to-slash.html
     */
    if (!/\/$/.test(urlObject.sh_pathname)) {
      urlObject.sh_pathname = "".concat(urlObject.sh_pathname, "/");
    }
  } else {
    token1 = NS;
    if (isSupportedLang(token0)) {
      /*
       * AppOrStaticPage
       * pattern:  /lang/.*
       */
      urlObject.sh_lang = token0;
      shPathname = urlObject.sh_pathname = "/".concat(splits.slice(1).join('/'));
    } else {
      /*
       * AppOrStaticPage
       * pattern:  /.*
       */
      token0 = NS;
    }
  }
  for (var index = 0; index < PAGE_KEYS.length; index++) {
    var pageKey = PAGE_KEYS[index];
    if (PAGE_ID_REGEX_MAP[pageKey].test(shPathname)) {
      urlObject.sh_page_id = pageKey;
      break;
    }
  }
}; // ParseShUrlProperties
exports.parseShUrlProperties = parseShUrlProperties;
var isScriptUrl = function isScriptUrl(url) {
  return !!(url && reg_js.test(url));
};
exports.isScriptUrl = isScriptUrl;
var isFullUrl = function isFullUrl(url) {
  return /^http/i.test(url);
};

/**
 * Domain Structure Regex List:
 * [For *.co.uk / *.co.at, have to define a specific pattern]
 * UK_STYLE_FULL    - www.stubhub.co.uk
 * UK_STYLE_PARTIAL - stubhub.co.uk
 * STANDARD_FULL    - www.stubhub.com
 * STANDARD_PARTIAL - stubhub.com
 * LOCALHOST_STYLE  - localhost:3000
 */
exports.isFullUrl = isFullUrl;
var DOMAIN_STRUCTURE_REGEX = {
  UK_STYLE_FULL: /^[\w-]*\.\w*\.\w{2}\.\w{2}$/,
  UK_STYLE_PARTIAL: /^\w*\.\w{2}\.\w{2}$/,
  STANDARD_FULL: /^[\w-]*\.\w*\.\w*$/,
  STANDARD_PARTIAL: /^\w*\.\w*$/,
  LOCALHOST_STYLE: /^\w*:\d*$/
};

/**
 * Structure style constants
 */
var UK_STYLE_FULL = 'UK_STYLE_FULL';
var UK_STYLE_PARTIAL = 'UK_STYLE_PARTIAL';
var STANDARD_FULL = 'STANDARD_FULL';
var STANDARD_PARTIAL = 'STANDARD_PARTIAL';
var LOCALHOST_STYLE = 'LOCALHOST_STYLE';

/**
 *
 * @param {Object} host
 */
var analyzeHostStructure = function analyzeHostStructure(host) {
  if (host.match(DOMAIN_STRUCTURE_REGEX.UK_STYLE_FULL)) {
    return UK_STYLE_FULL;
  }
  if (host.match(DOMAIN_STRUCTURE_REGEX.UK_STYLE_PARTIAL)) {
    return UK_STYLE_PARTIAL;
  }
  if (host.match(DOMAIN_STRUCTURE_REGEX.STANDARD_FULL)) {
    return STANDARD_FULL;
  }
  if (host.match(DOMAIN_STRUCTURE_REGEX.STANDARD_PARTIAL)) {
    return STANDARD_PARTIAL;
  }
  if (host.match(DOMAIN_STRUCTURE_REGEX.LOCALHOST_STYLE)) {
    return LOCALHOST_STYLE;
  }
};

/**
 * Parse partial url path
 * @param {String} host
 */
var parseHostWithPartialStyle = function parseHostWithPartialStyle(host) {
  var domainArray = host.split('.').reverse();
  var domainName = domainArray.pop();
  var domainSuffix = domainArray.reverse().join('.');
  return {
    domainName: domainName,
    domainSuffix: domainSuffix
  };
};

/**
 * Parse full url path
 * @param {String} host
 */
var parseHostWithFullStyle = function parseHostWithFullStyle(host) {
  var domainArray = host.split('.').reverse();
  var subDomain = domainArray.pop();
  var domainName = domainArray.pop();
  var domainSuffix = domainArray.reverse().join('.');
  return {
    subDomain: subDomain,
    domainName: domainName,
    domainSuffix: domainSuffix
  };
};

/**
 * Get domain name of specific url
 * Usage: setting cookies on first level domain instead of subdomain so that all stubhub platform could share (Login info)
 * @param {String} url
 */
var getDomainName = function getDomainName(url) {
  var _parseUrl = parseUrl(url),
    host = _parseUrl.host;
  var domainMap = {};
  var structureIdentity = analyzeHostStructure(host);
  switch (structureIdentity) {
    case UK_STYLE_FULL:
      domainMap = parseHostWithFullStyle(host);
      break;
    case UK_STYLE_PARTIAL:
      domainMap = parseHostWithPartialStyle(host);
      break;
    case STANDARD_PARTIAL:
      domainMap = parseHostWithPartialStyle(host);
      break;
    case STANDARD_FULL:
      domainMap = parseHostWithFullStyle(host);
      break;
    case LOCALHOST_STYLE:
      return 'localhost';
    default:
      return '';
  }
  return [domainMap.domainName, domainMap.domainSuffix].join('.');
};
exports.getDomainName = getDomainName;